<h2 class="_sansSerif _primary"[i18nKey]="'intro.rooms.title'"></h2>

<kiwi-spacer [size]="24"></kiwi-spacer>

<h3 [i18nKey]="'intro.rooms.subtitle.1'"></h3>
<p [i18nKey]="'intro.rooms.paragraph.1'"></p>
<p [i18nKey]="'intro.rooms.paragraph.2'"></p>
<p [i18nKey]="'intro.rooms.paragraph.3'"></p>
<p [i18nKey]="'intro.rooms.paragraph.4'"></p>
<p [i18nKey]="'intro.rooms.paragraph.5'"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.rooms.subtitle.2'"></h3>
<p [i18nKey]="'intro.rooms.paragraph.6'"></p>
<ul>
    <li [i18nKey]="'intro.rooms.element.1'"></li>
    <li [i18nKey]="'intro.rooms.element.2'"></li>
    <li [i18nKey]="'intro.rooms.element.3'"></li>
</ul>

<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.rooms.subtitle.3'"></h3>
<p [i18nKey]="'intro.rooms.paragraph.7'"></p>
<p [i18nKey]="'intro.rooms.paragraph.8'"></p>
<p [i18nKey]="'intro.rooms.paragraph.9'"></p>
<ul>
    <li [innerHTML]="'intro.rooms.element.4'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.rooms.element.4'}]"></li>
    <li [innerHTML]="'intro.rooms.element.5'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.rooms.element.5'}]"></li>
</ul>

<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.rooms.subtitle.4'"></h3>
<p [i18nKey]="'intro.rooms.paragraph.10'"></p>
<p [i18nKey]="'intro.rooms.paragraph.11'"></p>
<p [i18nKey]="'intro.rooms.paragraph.12'"></p>

<div class="infoImg"></div>
